import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

@Injectable()
export class BookingAllowedLinkedProductService {
  constructor(private http: HttpClient) {}

  public createOne(bookingId: number, productId: number): Observable<boolean> {
    return this.http.post<any>(
      `${environment.backendApiUrl}/bookings/${bookingId}/allowed-linked-product-links`,
      { bookingId, productId }
    )
  }

  public createMany(
    entities: { bookingId: number; productId: number }[]
  ): Observable<boolean> {
    return this.http.post<any>(
      `${environment.backendApiUrl}/bookings/${entities[0].bookingId}/allowed-linked-product-links/bulk`,
      { bulk: entities }
    )
  }

  public deleteOne(bookingId: number, productId: number): Observable<boolean> {
    return this.http.delete<any>(
      `${environment.backendApiUrl}/bookings/${bookingId}/allowed-linked-product-links/${productId}`
    )
  }
}
